module.exports = __webpack_public_path__ + "img/green-arrow-up.103eea7d.svg";